module.exports = __webpack_public_path__ + "static/media/google-icon.407ca4c2.svg";